module.exports = __webpack_public_path__ + "img/homeTag-icon-5.8b58ad3e.svg";